import { render, staticRenderFns } from "./SongwriterIndex.vue?vue&type=template&id=5fb7b519"
import script from "./SongwriterIndex.vue?vue&type=script&lang=js"
export * from "./SongwriterIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports